import React, { useRef, useEffect, useCallback, useState} from 'react';
import {ZMESSAGE} from 'constants/object-types.js';
import {connect} from 'react-redux';
import VariableName from './varz/VariableName.js';
import VariableValue from './varz/VariableValue.js';
import {setSelectedZObject} from 'actions/index.js';
import './varz/varz.scss';

const VarzUX = ({pattr, planeMapping}) => { 
    let ref = useRef();
    let [variables, setVariables] = useState([]);
    let [hiddenObjects, setHiddenObjects] = useState(pattr.hiddenObjects);
    useEffect(() => {
        setVariables(pattr.getOptionsAtLevel());
    }, [setVariables, pattr]);

    let isBase = !pattr.subpatch.zObject;
    useEffect(() => {
        if (!ref.current) {
            return undefined;
        }
        if (isBase) {
            ref.current.addEventListener("mousewheel", killScroll);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener("mousewheel", killScroll);
            }
        };
    }, [isBase]); 

    const hideObject = useCallback((x) => {
        pattr.hideObject(x);
        setHiddenObjects([... pattr.hiddenObjects]);
    }, [setHiddenObjects, pattr]);

    const createParameters = useCallback(() => {
        pattr.createParameters();
    }, [pattr]);

    const onClickLevel = useCallback(() => {
        if (!planeMapping) {
            return;
        }

        createParameters();
        let parameters = pattr.parameters;
        planeMapping.randomlyMapParameters(pattr);
    }, [pattr, planeMapping]);

    const killScroll = (e) => e.stopPropagation();


    return (
        <div ref={ref} className={isBase ? "varz base" : "varz"}>
          <div
            onClick={onClickLevel}
            className={planeMapping ? "varz-level plane-mapping" : "varz-level"}>
            <div className="varz-name">{pattr.subpatch.zObject ? pattr.subpatch.zObject.args[0] : ""}
            </div>
            <div
              onClick={createParameters} className="create-parameters">
              Create Parameters
            </div>
          </div>
          <div className={isBase  ? "varz-options base-level" : "varz-options"}>
            {variables
             .filter(x => !pattr.hiddenObjects.includes(x))
             .map(x =>
                <div
                  key={x.id}
                  onClick={() => pattr.subpatch.dispatch(setSelectedZObject(x))}
                  className="varz-option">
                  <VariableName variable={x} pattr={pattr}/>
                  <VariableValue variable={x}/>
                  <div onClick={e => hideObject(x)}className="hide">Hide</div>
                </div>)}
            {pattr.getNextLevels()
             .filter(x => x.getOptionsAtLevel().length > 0 || x.getNextLevels().length > 0)
             .map(
                 _pattr => <VarzUX
                             planeMapping={planeMapping}
                             key={_pattr.subpatch.id}
                             pattr={_pattr}/>)}
          </div>
        </div>);
};

export default VarzUX;
